export default __webpack_public_path__ + "ebeb323277a87afc520e9766bb2eca9f.svg";